export const getAutoPlay = ({ autoPlay = false }) => autoPlay;
